import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mobile/fi-rr-angle-small-right.svg'
import _imports_1 from '@/assets/images/mobile/success-icon.png'


const _hoisted_1 = { class: "container-mobile bg-white overflow-auto" }
const _hoisted_2 = { class: "content bg-white" }
const _hoisted_3 = { class: "header d-flex text-black p-3 custom-fs-18 container-390 position-fixed align-items-center justify-content-between" }
const _hoisted_4 = { class: "mx-auto fw-medium pe-4 fs-22-custom" }
const _hoisted_5 = { class: "content-all-points px-3 d-flex flex-column align-items-center text-center withdraw-seccess-content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "success"
}, null, -1)
const _hoisted_7 = { class: "withdraw-success-title text-black mt-3" }
const _hoisted_8 = { class: "withdraw-success-des mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          role: "button",
          src: _imports_0,
          alt: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.BackToMyPoints()))
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.local.withdraw_suc_1), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.local.withdraw_suc_2), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.local.withdraw_suc_3), 1)
      ])
    ])
  ]))
}